<template>
  <div class="box10">
    <pageTitle
      title="硬核师资&nbsp;&nbsp;精磨高标准课程"
      text="技术大牛倾力研发，专职沉淀AI新技术"
    />

    <div class="top-box">
      <div class="block">
        <p>20名+</p>
        AI技术大牛
      </div>
      <div class="block">
        <p>5年+</p>
        AI从业经验年限平均
      </div>
      <div class="block">
        <p>300+</p>
        技术研讨次数
      </div>
    </div>

    <div class="teacher-box">
      <div
        class="teacher"
        v-for="(item, index) in list"
        :key="index"
        :style="
          `backgroundImage: url(` +
          require(`../../../assets/coursePage/ai/box10/${index + 1}.png`) +
          `)`
        "
        @click="changeCur(index)"
      >
        <div class="tName">{{ item.name }}老师</div>
        <p v-html="item.p"></p>
      </div>
    </div>

    <van-popup v-model="show" position="bottom" round>
      <div class="pop">
        <div class="pop-top">
          <div class="title">{{ list[this.cur].name }}老师</div>

          <div class="close" @click="show = false"></div>
        </div>

        <div class="tag-box">
          <div
            class="tag"
            v-for="(item, index) in list[this.cur].tag"
            :key="index"
            :class="'tag' + (index + 1)"
          >
            {{ item }}
          </div>
        </div>

        <p
          v-for="(j, index1) in list[cur].info"
          :key="index1"
          :class="{ word: cur == 2 && index1 == 0 }"
        >
          <span></span>
          {{ j }}
        </p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      cur: 0,
      show: false,
      list: [
        {
          name: "李",
          tag: ["北京化工大学工学硕士", "多家互联网公司首席算法专家"],
          p: "北京化工大学工学硕士<br />多家互联网公司首席算法...",
          info: [
            "具备多年机器学习，深度学习等人工智能相关算法的研发经验；",
            "熟悉Python、Java等常用开发语言；",
            "对PyTorch、Tensorflow、PaddlePaddle等深度学习框架熟练使用；",
            "在自然语言处理应用方面具备多年的企业实践经验。"
          ],
        },
        {
          name: "李",
          tag: ["硕士", "高级算法专家"],
          p: "硕士<br />高级算法专家",
          info: [
            "曾就职于多家上市公司，并担任高级算法工程师、算法专家；",
            "研究领域包括NLP、目标检测、视频跟踪、大语言模型、多模态、模型推理加速等。",
          ],
        },
        {
          name: "赵",
          p: "人工智能领域技术大佬",
          tag: ["人工智能领域技术大佬"],
          info: [
            "曾任职美团搜索部，负责NER及Bert搜索排序优化；",
            "多年模式识别和数据挖掘开发经验，主导研发多项科研项目；",
            "曾负责信贷风控模型和智能医疗数据平台开发，专注ML/DL/PR/KG领域相关算法的应用；",
            "对Hadoop、SparkTensorflow和Pytorch等大数据、人工智能技术有多年企业实践经验。",
          ],
        },
        {
          name: "姚",
          p: "哈尔滨工程大学硕士<br />GIS行业工程实战大佬",
          tag: ["哈尔滨工程大学硕士", "GIS行业工程实战大佬"],
          info: [
            "在图像分割、检测、追踪等方面有多年从业经历；",
            "曾参与多项重大项目，具备丰富的工程落地经验；",
            "对Tensorflow和Pytorch有丰富的使用经验，对于二维和三维图像方面有深入了解。",
          ],
        },
       
      ],
    };
  },
  methods: {
    changeCur(index) {
      this.show = true;
      this.cur = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.box10 {
  padding: 80px 0 58px;
  width: 100%;
  background: url("../../../assets/coursePage/ai/box10/bg.png") no-repeat;
  background-size: cover;

  .word {
    white-space: nowrap;
  }

  .top-box {
    display: flex;
    justify-content: space-evenly;
    margin: 0 auto;
    margin-top: 48px;
    margin-bottom: 46px;
    padding-top: 24px;
    width: 686px;
    height: 136px;
    background: rgba(255, 255, 255, 0.4);
    box-shadow: 0px 4px 40px 0px rgba(22, 93, 255, 0.06);
    border-radius: 20px;
    box-sizing: border-box;

    .block {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #86909c;
      line-height: 40px;
      text-align: center;
    }

    p {
      margin-bottom: 8px;
      font-size: 32px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: #2ea5fc;
      line-height: 48px;
    }
  }

  .teacher-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0 auto;
    width: 654px;

    .teacher {
      margin-bottom: 30px;
      padding-left: 24px;
      width: 310px;
      height: 392px;
      background-size: cover;
      background-repeat: no-repeat;
      box-sizing: border-box;
      color: #fff;
      .tName {
        margin-top: 276px;
        font-size: 28px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #ffffff;
        line-height: 40px;
      }
      p {
        margin-top: 4px;
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 28px;
      }
    }
  }

  .pop {
    padding: 40px 46px;
    padding-bottom: 80px;

    box-sizing: border-box;
    .pop-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      .title {
        height: 48px;
        font-size: 32px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #1d2129;
        line-height: 48px;
      }
    }
    .close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }

    .tag-box {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 32px;
    }

    .tag {
      margin-right: 16px;
      padding: 0px 16px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      background: #e8f3ff;
      border-radius: 8px;

      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #165dff;
    }

    .tag2 {
      height: 44px;
      background: #fff7e8;
      border-radius: 8px;

      color: #ff7d00;
    }

    p {
      position: relative;
      // display: flex;
      margin-bottom: 16px;
      padding-left: 24px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;

      span {
        position: absolute;
        top: 16px;
        left: 0px;
        margin-right: 16px;
        min-width: 8px;
        height: 8px;
        background: #becfff;
        border-radius: 50%;
      }
    }
  }
}
</style>
